export const useComfortableViewAvailable = reportConfig => !!reportConfig?.comfortableRowHeight;
